import React, { ReactNode } from 'react'

import classnames from 'classnames'
import styles from './CircularIconButton.module.sass'

/** @interface CircularIconButton */
export interface CircularIconButtonProps {
  /** The icon to be displayed inside the button. */
  icon?: ReactNode
  /** Indicates whether the button is in a selected state. */
  isSelected?: boolean
  /** Determines if the button is hoverable. */
  isHoverable?: boolean
  /** Determines if the button is clickable. */
  isClickable?: boolean
  /** Disables the button if set to true */
  disabled?: boolean
  /** Callback function to handle click events. */
  onClick?: (e: React.MouseEvent) => void
}

/**
 * @component
 * CircularIconButton renders an styled circular button with an icon mainly used in GalleryImage component.
 */
export const CircularIconButton: React.FC<CircularIconButtonProps> = ({
  icon,
  isSelected = false,
  isHoverable = true,
  isClickable = true,
  disabled = false,
  onClick,
}) => {
  return (
    <button // TODO: Use the material button component IconButton and adjust styles accordingly
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation()
        if (onClick && isClickable && !disabled) {
          onClick(e)
        }
      }}
      className={
        classnames(
          styles.iconButton,
          {
            [styles.selected]: isSelected,
            [styles.hovered]: isHoverable && !disabled,
            [styles.clickable]: isClickable,
            [styles.notClickable]: !isClickable,
            [styles.disabled]: disabled,
          }
        )
      }
    >
      {icon}
    </button>
  )
}
